
interface DatadogConfig {
    DdrClientToken: string;
    DdrSite: string;
    DdrService: string;
    CurrentEnv: string;
  }
  
const defaultDatadogConfig: DatadogConfig = {
    DdrClientToken: "",
    DdrSite: "",
    DdrService: "",
    CurrentEnv: "",
  };

let isInitiated = false;
  
import { datadogLogs } from '@datadog/browser-logs'

const initializeDatadogLogs = (config: DatadogConfig = defaultDatadogConfig) => {
    if (config.CurrentEnv === "dev" || isInitiated) {
        return;
      }
    isInitiated = true;
    return datadogLogs.init({  
        clientToken:config.DdrClientToken,
        site: config.DdrSite,
        service: config.DdrService,
        forwardErrorsToLogs: true, // This is important for logging errors.
        sessionSampleRate: 100,
        trackingConsent: 'granted',
    });
  
  };
  
  export default initializeDatadogLogs;
  